import {Chip} from "@mui/material";
import React from "react";

// Estado de revisión de un documento de empresa (#13729), tal como lo calcula la API.
const ESTADOS: Record<string, { label: string, color: "default" | "success" | "warning" | "error" }> = {
    SIN_REVISION: {label: "Sin revisión", color: "default"},
    VIGENTE: {label: "Vigente", color: "success"},
    POR_REVISAR: {label: "Por revisar", color: "warning"},
    CADUCADO: {label: "Caducado", color: "error"},
};

export const ReviewStatusChip = ({status}: { status?: string }) => {
    const estado = ESTADOS[status || "SIN_REVISION"] || ESTADOS.SIN_REVISION;
    return <Chip size={"small"} color={estado.color} label={estado.label}/>;
};
